import { useTranslation } from "react-i18next";
import { useNavigate } from "react-router-dom";

import { PATHS } from "@router/paths";

import NotFoundLayout from "@components/layouts/NotFoundLayout/NotFoundLayout";
import Button from "@components/toolkit/Button/Button";

import "./NotFound.scss";

const NotFound = () => {
  const { t } = useTranslation("notFound");

  const navigate = useNavigate();
  const goToHomePage = () => navigate(PATHS.main.path);

  return (
    <div className="not-found">
      <img src="/images/layouts/hero-app-preview-bg-mobile.png" alt="background blur" className="not-found-bg-mobile" />
      <img
        src="/images/layouts/hero-app-preview-bg-desktop.jpg"
        alt="background blur"
        className="not-found-bg-desktop"
      />

      <div className="not-found-content">
        <h1 className="title">404</h1>
        <p className="subtitle">{t("subTitle")}</p>

        <Button onClick={goToHomePage} className="mt-5">
          {t("return")}
        </Button>
      </div>
    </div>
  );
};

export default (
  <NotFoundLayout>
    <NotFound />
  </NotFoundLayout>
);
